import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = '/api/tabOption'

export const tabOptionService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    syncFirebase,
    translate,
};


function search(offset, max, data) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', data)
}

function syncFirebase() {
    return utilHelper.doRequest(`${relativeUrl}/syncFirebase`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}